// extracted by mini-css-extract-plugin
export default {"Loader":"SpinnerDark_Loader__-ayYA","load7":"SpinnerDark_load7__D94kr"};